import { render } from "./TenantUsers.vue?vue&type=template&id=6a167bde&scoped=true"
import script from "./TenantUsers.vue?vue&type=script&lang=js"
export * from "./TenantUsers.vue?vue&type=script&lang=js"

import "./TenantUsers.vue?vue&type=style&index=0&id=6a167bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a167bde"]])

export default __exports__